export const ENVIRONMENTAL_COLOR = '#56B877';
export const SOCIAL_COLOR = '#2751FF';
export const GOVERNANCE_COLOR = '#D1C5C5';
export const ESG_COLOR = '#6F9ABE';
